import { MadSDKAPIError } from "../../errors/base";
export class RecipeFetchFailed extends MadSDKAPIError {
    /**
     * @param apiError: the error received from the API.
     */
    constructor(apiError) {
        super(apiError, "Failed to fetch recipe(s).");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RecipeFetchFailed);
        }
        this.name = "RecipeFetchFailed";
    }
}
export class RecipeSaveFailed extends MadSDKAPIError {
    /**
     * @param apiError: the error received from the API.
     */
    constructor(apiError) {
        super(apiError, "Failed to save recipe(s).");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RecipeSaveFailed);
        }
        this.name = "RecipeSaveFailed";
    }
}
export class RecipeMatchFailed extends MadSDKAPIError {
    /**
     * @param apiError: the error received from the API.
     */
    constructor(apiError) {
        super(apiError, "Failed to check if recipe matches any other.");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RecipeMatchFailed);
        }
        this.name = "RecipeMatchFailed";
    }
}
export class RecipePatchFailed extends MadSDKAPIError {
    /**
     * @param apiError: the error received from the API.
     */
    constructor(apiError) {
        super(apiError, "Failed to patch recipe(s).");
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RecipePatchFailed);
        }
        this.name = "RecipePatchFailed";
    }
}
//# sourceMappingURL=errors.js.map